export default __webpack_public_path__ + "static/media/2.590db324.jpg";